import { useEffect } from "react";
import { trackingAllowed } from "../lib/analytics";

const PARTNER_ID = "9787234";

// Loads the LinkedIn Insight Tag once (idempotent). Mounted only on high-intent
// pages (LPG Demo, Book a Shoot). Respects consent: won't load if the visitor
// has opted out. Once loaded, insight.min.js auto-tracks SPA navigations.
export default function LinkedInInsight() {
  useEffect(() => {
    if (!trackingAllowed()) return;
    window._linkedin_partner_id = PARTNER_ID;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    if (!window._linkedin_data_partner_ids.includes(PARTNER_ID)) {
      window._linkedin_data_partner_ids.push(PARTNER_ID);
    }
    if (!window.lintrk) {
      window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
      window.lintrk.q = [];
    }
    if (window.__li_insight_loaded) return;
    window.__li_insight_loaded = true;
    const s = document.getElementsByTagName("script")[0];
    const b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  }, []);
  return null;
}
